import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Premium Volumes', '✅ 5 Bonus Guides FREE'], ['✅ 610+ Pages', '✅ 100 Printable Resources'], ['✅ 65 Constellation Maps', '✅ 200 Healing Flashcards']];
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/f5ts9GSVgu3fXThSGq17JD/ChatGPT_Image_22_jul_2026,_11_19_23_a.m..png';
export function Hero() {
  return <>
    <section className="w-full bg-mist px-4 py-4 text-navy sm:py-6" data-id="element-108" data-mp="128yxm77pblw0">
      <div className="mx-auto max-w-5xl text-center" data-id="element-109" data-mp="xa4gratao7ej">
        <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber" data-id="element-110" data-mp="x8bc2128rx96">Family Healing</motion.span>
        <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05
        }} className="mx-auto mt-3 max-w-3xl font-serif text-4xl leading-[0.98] tracking-tight text-navy sm:text-6xl" data-id="element-111" data-mp="3d2tln1u126au">Therapeutic Family Constellations™</motion.h1>
        <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.16
        }} className="mx-auto mt-3 max-w-md text-sm leading-snug text-slate sm:text-base" data-id="element-112" data-mp="3o6amdlpjdov7">Order your system. Save your history. Ready-to-use constellation maps, healing scripts, genogram templates, and printable resources to break generational patterns and rewrite your family story — forever.</motion.p>
        <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-5 max-w-3xl text-center" data-id="element-113" data-mp="35a2jupnwrs3l">
          <p className="text-xs font-bold uppercase tracking-[0.12em] text-amber" data-id="element-114" data-mp="2vjpzaxg3fyxg">📦 Everything You Get Instantly</p>
          <div className="mt-2 space-y-1 text-xs font-medium text-slate sm:text-sm" data-id="element-115" data-mp="2hjyo14gyown5">{benefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap justify-center gap-x-5 gap-y-1" data-id="element-116" data-mp="2ljz1alsbr1sm">{row.map(benefit => <span key={benefit} data-id="element-117" data-mp="s3cm2bn71lr3">{benefit}</span>)}</p>)}</div>
        </motion.div>
        <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-5 max-w-3xl" data-id="element-118" data-mp="najj9tbacnhn"><img src={mockupUrl} alt="Therapeutic Family Constellations complete healing system mockup" className="mx-auto block h-auto w-full max-w-2xl rounded-3xl object-contain shadow-elevated" data-id="element-119" data-mp="ddf2k907lk88" /></motion.div>
        <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-5" data-id="element-120" data-mp="161ayhbhyf83y"><CTAButton href="#complete-package" pulse size="large" data-id="element-121" data-mp="111ew1gownoqi">GET INSTANT ACCESS</CTAButton><p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-122" data-mp="x030yvn9ibax">📄 High-Quality PDF <span className="mx-1" data-id="element-123" data-mp="3lu026z6yb0yo">·</span> 🖨️ Printable Resources <span className="mx-1" data-id="element-124" data-mp="3hrd80rmt53yb">·</span> ⚡ Instant Download <span className="mx-1" data-id="element-125" data-mp="3hqkbsklh5wuf">·</span> 🔒 Secure Payment <span className="mx-1" data-id="element-126" data-mp="1x9b590wn91ck">·</span> 🛡️ 30-Day Guarantee</p></motion.div>
      </div>
    </section>
    <section className="border-y border-amber/40 bg-surface px-4 py-5 text-navy" data-id="element-127" data-mp="21awe8b624vhh"><div className="mx-auto max-w-3xl text-center" data-id="element-128" data-mp="218tols8th4da"><p className="text-sm font-bold sm:text-base" data-id="element-129" data-mp="269r4tza9noc5">🚀 Launch offer active — All 5 Bonus Guides FREE with purchase · Price increases when the timer hits zero</p><div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-amber/20" data-id="element-130" data-mp="2b2soeklf4c22"><div className="h-full w-[72%] rounded-full bg-amber" data-id="element-131" data-mp="2fzarzh50i4ct" /></div><p className="mt-2 text-xs font-medium text-slate" data-id="element-132" data-mp="2ky43x54nhnav">72% of launch spots already claimed</p></div></section>
  </>;
}